import { YEARFRAC } from 'common/formulas/math.js';
import { BASIS_3_VALUE } from 'pages/CapTable/cap-table/components/liquidation-preference-ledger/liq-pref-ledger-table-config/constants';
import { getNumberValue } from 'utilities';

export interface DividendsPerShareAtDateParams {
  hasCumulativeDividends: boolean;
  periodStartDate: string;
  hasCompounding: boolean;
  periodEndDate: string;
  periodIssuePrice: number;
  compoundingPeriods?: number | null;
  dividendRate: number;
  yearfracBasis?: number;
}

const dividendsPerShareAtDate = (params: DividendsPerShareAtDateParams) => {
  const {
    hasCumulativeDividends,
    periodStartDate,
    hasCompounding,
    periodEndDate,
    periodIssuePrice,
    compoundingPeriods,
    dividendRate,
    yearfracBasis = BASIS_3_VALUE,
  } = params;
  if (!hasCumulativeDividends || !periodStartDate) return 0;
  const yearFracTerm = Number(YEARFRAC(periodStartDate, periodEndDate, yearfracBasis));
  if (hasCompounding) {
    return (
      periodIssuePrice *
        (1 + dividendRate / getNumberValue(compoundingPeriods)) ** (yearFracTerm * getNumberValue(compoundingPeriods)) -
      periodIssuePrice
    );
  }
  return periodIssuePrice * dividendRate * yearFracTerm;
};

export default dividendsPerShareAtDate;
